import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { CheckCircleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const FEATURE_BULLETS = {
  // Trial Awareness Modal Experiment Variants
  variant_1: ['save_hours', 'look_professional', 'grow_business'],
  variant_2: ['automate', 'connect', 'customize', 'collaborate'],
  // Retrials Experiment Variant (uses same text as variant_2)
  variant: ['automate', 'connect', 'customize', 'collaborate']
};
const gridContainerIsSmallPhoneCss = "g1ic8gkl";
const gridContainerCss = "g7sihgk";
const GridContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} isPhone={isPhone} className={classNames(gridContainerCss, {
    [gridContainerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const gridItemCss = "gofu8lp";
const GridItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(gridItemCss, props.className)} />;
});
const iconContainerCss = "i1c881fj";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const textContainerCss = "t1ritaxg";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
const FeatureText = ({
  feature,
  experimentValue
}) => {
  if (experimentValue === 'variant_1') {
    return <>
        <BodyText>
          {HtmlParser(I18n.t(`publisher.trial_start.variant_1.${feature}.title`))}
        </BodyText>
        <BodyText>
          {HtmlParser(I18n.t(`publisher.trial_start.variant_1.${feature}.description`))}
        </BodyText>
      </>;
  }
  if (experimentValue === 'variant_2'
  // Retrials Experiment "variant" uses same text as variant_2
  || experimentValue === 'variant') {
    return <BodyText>
        {HtmlParser(I18n.t(`publisher.trial_start.variant_2.${feature}`))}
      </BodyText>;
  }
  return null;
};
const FeatureItem = ({
  feature,
  experimentValue
}) => <GridItem>
    <IconContainer>
      <CheckCircleIcon color={colorTextStandard} />
    </IconContainer>
    <TextContainer>
      <FeatureText feature={feature} experimentValue={experimentValue} />
    </TextContainer>
  </GridItem>;
export const FeatureGrid = ({
  experimentValue
}) => {
  const features = FEATURE_BULLETS[experimentValue];
  if (!features) {
    return null;
  }
  return <GridContainer>
      {features.map(feature => <FeatureItem key={feature} feature={feature} experimentValue={experimentValue} />)}
    </GridContainer>;
};

require("./feature_grid.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./feature_grid.js");